import React from 'react';
import {
  InputAdornment,
  IconButton,
  Popper,
  makeStyles,
  Grid,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { BaseTextField } from '../BaseTextField';
import { BaseCard } from '../../BaseCard/BaseCard';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { PasswordHint } from './PasswordHint';

const visibilityIconStyles = { height: '20px', fill: '#969696' };

// Todo: refactor
const useStyles = makeStyles(() => ({
  popperBlock: {
    zIndex: 3,
    filter: 'drop-shadow(0px 9.92857px 26.4762px rgba(0, 0, 0, 0.08))',
    boxShadow:
      '0px 14.8929px 46.3333px 13.2381px rgba(0, 0, 0, 0.05), 0px 4.96429px 9.92857px -6.61905px rgba(0, 0, 0, 0.12)',
    // Todo: implement for all states
    // '&::before': {
    //   content: '""',
    //   zIndex: 3,
    //   display: 'block',
    //   width: '0',
    //   height: '0',
    //   position: 'absolute',
    //   top: '-5px',
    //   left: '50%',
    //   transform: 'translateX(-50%)',
    //   borderBottom: '5px solid white',
    //   borderLeft: '5px solid transparent',
    //   borderRight: '5px solid transparent',
    // },
  },
  popperCard: {
    maxWidth: '280px',
    padding: '10px',
  },
}));

export const PasswordTextField: React.FC<any> = (props) => {
  const {
    label = 'Password',
    canHintBeVisible = false,
    value,
    ...otherProps
  } = props;
  const [isPasswordVisible, setPasswordVisibility] = React.useState(false);

  const handleClickShowPassword = () => {
    setPasswordVisibility((prev) => !prev);
  };

  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const classes = useStyles();

  const extendedLabel = (
    <Grid container spacing={1} style={{ height: 'calc(19.2px + 8px)' }}>
      <Grid item>{label}</Grid>

      {canHintBeVisible && (
        <Grid item onClick={handleClick}>
          <InfoOutlinedIcon
            fontSize="small"
            color="primary"
            style={{ cursor: 'pointer' }}
          />
        </Grid>
      )}
    </Grid>
  );

  const popperRef = React.useRef<any>();

  return (
    <>
      <BaseTextField
        aria-describedby={id}
        type={isPasswordVisible ? 'text' : 'password'}
        label={extendedLabel}
        value={value}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                style={{ marginRight: '5px' }}
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {isPasswordVisible ? (
                  <Visibility style={visibilityIconStyles} />
                ) : (
                  <VisibilityOff style={visibilityIconStyles} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...otherProps}
      />
      <Popper
        id={id}
        popperRef={popperRef}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{
          zIndex: 9000,
        }}
        modifiers={{
          offset: {
            enabled: true,
            // We cant use offset as a function. I suppose material ui library use the first version of popper
            offset: '0,70',
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            fn: (data: any) => {
              // update top position
              return {
                ...data,
                offsets: {
                  ...data.offsets,
                  popper: {
                    ...data.offsets.popper,
                    top: data.placement.includes('bottom')
                      ? data.offsets.popper.top + 60
                      : data.offsets.popper.top - 5,
                  },
                },
              };
            },
          },
        }}
      >
        <div className={classes.popperBlock}>
          <BaseCard className={classes.popperCard}>
            <PasswordHint password={value} />
          </BaseCard>
        </div>
      </Popper>
    </>
  );
};
